import withType from 'components/common/hoc/withType'
import StoreLocatorPage from '../StoreLocatorPage'

export default withType({
  type: 'OneColumnStoreLocatorPage', placeholders: ['header', 'mainContent', 'footer']
})(StoreLocatorPage)
